import moment from 'moment'
import {omit, mapKeys} from 'lodash'
import React from 'react'
import Text from 'react-text'
import Links from './links'
import {Consumer} from '../../context'
import {sendAssessment} from '../../context/post'
import {enhancedWithRowData} from '../../helpers/utils'

function AssessmentHeader ({title}) {
  return (
    <span><Text id={`${title}_assessment_header`} /></span>
  )
}

function EmptyHeader () { return (<span />) }

function TitleColumn ({rowData}) {
  const {name, assigned} = rowData
  const assignedClass = `name${assigned ? ' assigned' : ''}`
  return (
    <div className={assignedClass} title={name}>
      <div className="bullet"></div>
      {name}
    </div>
  )
}

function CourseColumn ({value}) {
  return (<Consumer>{ context => {
    const course = context.myCourses.find(i => i.course == value)
    return (
      <div className="course-name">
        {course && (<label>{course.courseName}</label>)}
      </div>)
  }}</Consumer>)
}

function TypeColumn ({value}) {
  return (<Consumer>{ context => {
    const type = context.templateTypes.find(i => i.id == value)
    return (
      <div className="template-type">
        {type && (<label>{type.name}</label>)}
      </div>)
  }}</Consumer>)
}

function RandomizeColumn ({value, rowData}) {
  return (<Consumer>{ context => {
    const {assessmentViewUpdates} = context
    return (<input
      type="checkbox"
      checked={value}
      onChange={() => {
        sendAssessment(context.profile.Passport.id, {...omit(rowData,['griddleKey']), randomize: !value}).then(() =>context.setState({assessmentViewUpdates: assessmentViewUpdates + 1}))
      }}
    />)
  }}</Consumer>)
}

function AssessmentLinksColumn ({rowData}) {
  return (<Links {...rowData} />)
}

const map = {
  headers: {AssessmentHeader, EmptyHeader},
  columns: {
    TitleColumn: enhancedWithRowData(TitleColumn),
    TypeColumn,
    RandomizeColumn: enhancedWithRowData(RandomizeColumn),
    CourseColumn,
    AssessmentLinksColumn: enhancedWithRowData(AssessmentLinksColumn),
  }
}

export default map
